import React from 'react';
import ReactDOM from 'react-dom';
import './assets/scss/style.scss';
import './index.scss';

const App = require('./app').default;

ReactDOM.render( 
	<App /> , document.getElementById('root')
);